import { useState } from "react";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { PurposeSaveModel } from "../purposeDialog/PurposeDialog.types";
import { PurposeViewModel } from "./Purposes.types";

import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export function usePurposesDataMapping() {
    const queryClient = useDotLegalQueryClient();
    const [showAllPurposes, setShowAllPurposes] = useStateLocalStorage("onlyActivePurposes", false);
    const [showPurposeDialog, setShowPurposeDialog] = useState(false);
    const [showDeletePurposeDialog, setShowDeletePurposeDialog] = useState(false);
    const [selectedPurpose, setSelectedPurpose] = useState<PurposeSaveModel | undefined>(undefined);
    const [showChangeStatusDialog, setShowChangeStausDialog] = useState(false);

    const queryPart = `?showAllPurposes=${showAllPurposes}`;
    const url = `/Purposes${queryPart}`;
    let { isLoading, data } = useDotLegalQuery<Array<PurposeViewModel>>(url);

    const OnSave = () => {
        queryClient.refetchQueries(url);
    };

    return {
        isLoading,
        data,
        showAllPurposes,
        setShowAllPurposes,
        showPurposeDialog,
        setShowPurposeDialog,
        showDeletePurposeDialog,
        setShowDeletePurposeDialog,
        OnSave,
        selectedPurpose,
        setSelectedPurpose,
        showChangeStatusDialog,
        setShowChangeStausDialog,
    };
}
